import React, {useState} from "react";
import {Button, Row, Col, Modal, notification, Input, Typography} from "antd";
import '../modals.css';
import {deliveriesService} from "../../../services";
import i18n from "../../../i18n";

export default function ModalReturnToEnRoute({
                                               isShow, id, onCloseModal
                                             }) {
  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };
  const {Text} = Typography;
  const {TextArea} = Input;
  const [reason, setReason] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const onSignUp = () => {
    setIsDisabled(true);
    deliveriesService.returnToEnRoute(id, reason)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.returnToEnRoute'),
          description: response.message,
        });
        onCloseModal();
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.returnToEnRoute'), description: err,
        });
      })
      .finally(() => {
        setIsDisabled(false);
      })
  }

  return (<Modal
    title={<div>{i18n.t('modals.modalReturnToEnRoute.title')}</div>}
    cancelText={i18n.t('main.buttons.close')}
    className="modal-window"
    align={null}
    visible={isShow}
    onCancel={() => {
      onCloseModal();
    }}
    forceRender={true}
    footer={
      <Button htmlType="submit" key="submit" type="primary"
              style={bigButtonStyle}
              onClick={() => onSignUp()}
              disabled={reason === "" || isDisabled}
      >{i18n.t('main.buttons.send')}</Button>
    }
  >
    <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
      <Col span={24}>
        <Text strong style={{fontSize: "20px"}}>{i18n.t('modals.modalReturnToEnRoute.fields.reason.title')}</Text>
        <TextArea
          placeholder={i18n.t('modals.modalReturnToEnRoute.fields.reason.placeholder')}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value)
          }}
          rows={4}
          autoSize={{minRows: 4, maxRows: 8}}
          style={{marginTop: "20px"}}
        />
      </Col>
    </Row>
  </Modal>);
}
